import React from 'react'
import styled from '@emotion/styled'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { Link } from 'gatsby'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.text};
  color: ${props => props.theme.colors.background};
  overflow: hidden;
  border-right: 1px solid ${props => props.theme.colors.background};
  h1 {
    padding: 30px 15px;
    border-bottom: 2px solid #fff;
    z-index: 2;
    background-color: ${props => props.theme.colors.text};
    @media (min-width: ${props => props.theme.responsive.medium}) {
      padding: 30px;
    }
  }

  .auswertung {
    display: none;
  }

  &.auswerten .auswertung {
    display: flex !important;
    flex-flow: column;
  }

  &.auswerten > div,
  &.auswerten > a {
    display: none;
  }

  .auswertung #a-alle {
    display: none;
  }

  &.j1 .sc-select-1 .sc-option-ja {
    background-color: ${props => props.theme.colors.red};
  }
  &.j2 .sc-select-2 .sc-option-ja {
    background-color: ${props => props.theme.colors.red};
  }
  &.j3 .sc-select-3 .sc-option-ja {
    background-color: ${props => props.theme.colors.red};
  }
  &.j4 .sc-select-4 .sc-option-ja {
    background-color: ${props => props.theme.colors.red};
  }
  &.j5 .sc-select-5 .sc-option-ja {
    background-color: ${props => props.theme.colors.red};
  }

  &.n1 .sc-select-1 .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }
  &.n2 .sc-select-2 .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }
  &.n3 .sc-select-3 .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }
  &.n4 .sc-select-4 .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }
  &.n5 .sc-select-5 .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }

  &.j1 .auswertung #a-1 {
    display: none;
  }
  &.j2 .auswertung #a-2 {
    display: none;
  }
  &.j3 .auswertung #a-3 {
    display: none;
  }
  &.j4 .auswertung #a-4 {
    display: none;
  }
  &.j5 .auswertung #a-5 {
    display: none;
  }
  &.j1.j2.j3.j4.j5 .auswertung #a-alle {
    display: block;
  }

  #a-1 {
    border-left: 2px solid ${props => props.theme.colors.red};
  }
  #a-2 {
    border-left: 2px solid ${props => props.theme.colors.red};
  }
  #a-3 {
    border-left: 2px solid ${props => props.theme.colors.red};
  }
  #a-4 {
    border-left: 2px solid ${props => props.theme.colors.red};
  }
  #a-5 {
    border-left: 2px solid ${props => props.theme.colors.red};
  }
  #a-alle {
    border-left: 2px solid #fff;
  }
`

const ContainerSelfcheck = styled.div`
  flex: auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: row nowrap;
  padding: 30px 15px;
  border-bottom: 2px solid #fff;
  &:last-of-type {
    border-bottom: none;
  }

  &.cs-1 .sc-option {
    border-color: ${props => props.theme.colors.red} !important;
    &:hover {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }

  &.cs-1 .scn {
    color: ${props => props.theme.colors.red} !important;
  }

  &.cs-2 .sc-option {
    border-color: ${props => props.theme.colors.red} !important;
    &:hover {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }

  &.cs-2 .scn {
    color: ${props => props.theme.colors.red} !important;
  }

  &.cs-3 .sc-option {
    border-color: ${props => props.theme.colors.red} !important;
    &:hover {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }

  &.cs-3 .scn {
    color: ${props => props.theme.colors.red} !important;
  }

  &.cs-4 .sc-option {
    border-color: ${props => props.theme.colors.red} !important;
    &:hover {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }

  &.cs-4 .scn {
    color: ${props => props.theme.colors.red} !important;
  }

  &.cs-5 .sc-option {
    border-color: ${props => props.theme.colors.red} !important;
    &:hover {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }

  &.cs-5 .scn {
    color: ${props => props.theme.colors.red} !important;
  }

  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 20px 30px 40px;
  }

  @media (min-width: ${props => props.theme.responsive.medium}) {
    &:first-of-type {
      .sc-select:before {
        content: '';
        display: block;
        height: 5000px;
        width: 2px;
        background-color: #fff;
        z-index: -1;
        position: absolute;
        top: -500px;
        left: calc(50% - 59px);
        @media (min-width: ${props => props.theme.responsive.large}) {
          left: calc(50% - 69px);
        }
      }
    }
  }
`

const SelfcheckRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-flow: column;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex-flow: row nowrap;
  }
`

const SelfcheckContent = styled.div`
  flex: 1 1 auto;
`

const SelfcheckNumber = styled.div`
  font-size: ${props => props.theme.fontSizes[7]}px;
  color: ${props => props.theme.colors.red};

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    font-size: ${props => props.theme.fontSizes[6]}px;
  }
`

const SelfcheckTitle = styled.span`
  font-size: ${props => props.theme.fontSizes[2]}px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
  }
`

const SelfcheckText = styled.div`
  font-size: ${props => props.theme.fontSizes[3]}px;
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    font-size: ${props => props.theme.fontSizes[2]}px;
  }
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[1]}px;
  }
`

const SelfcheckSelect = styled.div``

const Button = styled.a`
  width: 100%;
  padding: 30px 15px;
  text-align: center;
  font-size: ${props => props.theme.fontSizes[7]}px;
  background-color: ${props => props.theme.colors.red};
  color: ${props => props.theme.colors.text};
  z-index: 4;
  cursor: pointer;
  opacity: 1 !important;

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    font-size: ${props => props.theme.fontSizes[5]}px;
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
  }

  &:hover {
    background-color: ${props => props.theme.colors.text};
    color: ${props => props.theme.colors.background};
    background-color: #ed6941;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='250' height='250' viewBox='0 0 20 20'%3E%3Cg %3E%3Cpolygon fill='%23000000' points='20 10 10 0 0 0 20 20'/%3E%3Cpolygon fill='%23000000' points='0 10 0 20 10 20'/%3E%3C/g%3E%3C/svg%3E");
  }
`

const Antwort = styled.div`
  padding: 5px 15px;
  margin-left: 15px;
  margin-top: 15px;
  margin-bottom: 5px;
  font-size: ${props => props.theme.fontSizes[1]}px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 10px 30px;
    margin-left: 30px;
    margin-top: 30px;
  }
`

const Hinweis = styled.div`
  margin-top: 30px;
  color: ${props => props.theme.colors.red};
  padding: 0 15px 15px;
  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 0 30px 30px;
  }

  a {
    display: block;
    color: ${props => props.theme.colors.red};
    font-size: ${props => props.theme.fontSizes[3]}px;
    font-weight: bold;
    margin-top: 5px;
  }
`

const OptionContainer = styled.div`
  flex: 0 0 500px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: center;
  z-index: 1;
  position: relative;
  .sc-option-nein {
    border-radius: 999px;
  }

  &.q-ja .sc-option-ja,
  &.q-nein .sc-option-nein {
    background-color: ${props => props.theme.colors.red};
  }
`

const Option = styled.div`
  cursor: pointer;
  background-color: ${props => props.theme.colors.text};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${props => props.theme.colors.red};
  width: 140px;
  height: 140px;
  margin-left: 40px;
  font-size: ${props => props.theme.fontSizes[7]}px;
  z-index: 3;
  &:hover,
  &.active {
    background-color: ${props => props.theme.colors.red};
  }

  @media (max-width: ${props => props.theme.responsive.largeMax}) {
    font-size: ${props => props.theme.fontSizes[6]}px;
    width: 120px;
    height: 120px;
    margin-left: 30px;
  }
  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    margin-top: 20px;
    font-size: ${props => props.theme.fontSizes[5]}px;
    width: 100px;
    height: 100px;
    margin-left: 20px;
  }
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
    width: 80px;
    height: 80px;
    margin-left: 15px;
  }
`

class ContentSelfcheck extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      q1: false,
      q2: false,
      q3: false,
      q4: false,
      q5: false,
    }
  }

  render() {
    return (
      <Container
        className={`sc-select ${this.state.active && this.state.active} ${this
          .state.q1 && this.state.q1} ${this.state.q2 && this.state.q2} ${this
          .state.q3 && this.state.q3} ${this.state.q4 && this.state.q4} ${this
          .state.q5 && this.state.q5}`}
      >
        {this.props.children}
        <ContainerSelfcheck className={'cs-1'}>
          <SelfcheckRow>
            <SelfcheckContent>
              <SelfcheckNumber className={'scn'}>
                1 <SelfcheckTitle>Zugänge</SelfcheckTitle>
              </SelfcheckNumber>
              <SelfcheckText>
                Haben Sie alle relevanten Adminkennwörter für Ihren Server,
                Firewall, Mailzugriff, Access Points etc. im Unternehmen? Sind
                diese an einem sicheren Ort verwahrt und haben Sie jederzeit
                Zugriff darauf? Gibt es eine schriftliche Dokumentation über
                Ihre IT-Infrastruktur?
              </SelfcheckText>
            </SelfcheckContent>
            <SelfcheckSelect>
              <OptionContainer
                className={`sc-select sc-select-1 ${this.state.active &&
                  this.state.active}`}
              >
                <Option
                  className="sc-option sc-option-ja"
                  onClick={() => this.setState({ q1: 'j1' })}
                >
                  ja
                </Option>
                <Option
                  className="sc-option sc-option-nein"
                  onClick={() => this.setState({ q1: 'n1' })}
                >
                  nein
                </Option>
              </OptionContainer>
            </SelfcheckSelect>
          </SelfcheckRow>
        </ContainerSelfcheck>

        <ContainerSelfcheck className={'cs-2'}>
          <SelfcheckRow>
            <SelfcheckContent>
              <SelfcheckNumber className={'scn'}>
                2 <SelfcheckTitle>Sicherungen</SelfcheckTitle>
              </SelfcheckNumber>
              <SelfcheckText>
                Wissen Sie, ob Ihre Server-Systeme regelmäßig gesichert werden?
                Gibt es jemand im Unternehmen oder ein dafür beauftragtes
                Unternehmen, das diese Sicherungen regelmäßig kontrolliert?
              </SelfcheckText>
            </SelfcheckContent>
            <SelfcheckSelect>
              <OptionContainer
                className={`sc-select sc-select-2 ${this.state.active &&
                  this.state.active}`}
              >
                <Option
                  className="sc-option sc-option-ja"
                  onClick={() => this.setState({ q2: 'j2' })}
                >
                  ja
                </Option>
                <Option
                  className="sc-option sc-option-nein"
                  onClick={() => this.setState({ q2: 'n2' })}
                >
                  nein
                </Option>
              </OptionContainer>
            </SelfcheckSelect>
          </SelfcheckRow>
        </ContainerSelfcheck>

        <ContainerSelfcheck className={'cs-3'}>
          <SelfcheckRow>
            <SelfcheckContent>
              <SelfcheckNumber className={'scn'}>
                3 <SelfcheckTitle>Hardware</SelfcheckTitle>
              </SelfcheckNumber>
              <SelfcheckText>
                Wissen Sie, wie alt die Hardware Ihres bestehenden Servers ist
                und ob es seitens des Herstellers noch eine
                Ersatzteilverfügbarkeit gibt? Wie lange würde es dauern, bis im
                Falle eines Hardwareausfalles Ihre Systeme wieder betriebsbereit
                sind?
              </SelfcheckText>
            </SelfcheckContent>
            <SelfcheckSelect>
              <OptionContainer
                className={`sc-select sc-select-3 ${this.state.active &&
                  this.state.active}`}
              >
                <Option
                  className="sc-option sc-option-ja"
                  onClick={() => this.setState({ q3: 'j3' })}
                >
                  ja
                </Option>
                <Option
                  className="sc-option sc-option-nein"
                  onClick={() => this.setState({ q3: 'n3' })}
                >
                  nein
                </Option>
              </OptionContainer>
            </SelfcheckSelect>
          </SelfcheckRow>
        </ContainerSelfcheck>

        <ContainerSelfcheck className={'cs-4'}>
          <SelfcheckRow>
            <SelfcheckContent>
              <SelfcheckNumber className={'scn'}>
                4 <SelfcheckTitle>IT Security</SelfcheckTitle>
              </SelfcheckNumber>
              <SelfcheckText>
                Werden auf Ihrem Server und Ihrer Firewall regelmäßig die
                erforderlichen Sicherheitsupdates gemacht, um etwaige
                Sicherheitslücken auszuschalten?
              </SelfcheckText>
            </SelfcheckContent>
            <SelfcheckSelect>
              <OptionContainer
                className={`sc-select sc-select-4 ${this.state.active &&
                  this.state.active}`}
              >
                <Option
                  className="sc-option sc-option-ja"
                  onClick={() => this.setState({ q4: 'j4' })}
                >
                  ja
                </Option>
                <Option
                  className="sc-option sc-option-nein"
                  onClick={() => this.setState({ q4: 'n4' })}
                >
                  nein
                </Option>
              </OptionContainer>
            </SelfcheckSelect>
          </SelfcheckRow>
        </ContainerSelfcheck>

        <ContainerSelfcheck className={'cs-5'}>
          <SelfcheckRow>
            <SelfcheckContent>
              <SelfcheckNumber className={'scn'}>
                5 <SelfcheckTitle>Passwortsicherheit</SelfcheckTitle>
              </SelfcheckNumber>
              <SelfcheckText>
                Sind die verwendeten Kennwörter Ihrer Systeme sicher?
                Entsprechen sie den gängigen verwendeten Sicherheitsrichtlinien
                und verfügen Sie dadurch über den erforderlichen Basisschutz?
              </SelfcheckText>
            </SelfcheckContent>
            <SelfcheckSelect>
              <OptionContainer
                className={`sc-select sc-select-5 ${this.state.active &&
                  this.state.active}`}
              >
                <Option
                  className="sc-option sc-option-ja"
                  onClick={() => this.setState({ q5: 'j5' })}
                >
                  ja
                </Option>
                <Option
                  className="sc-option sc-option-nein"
                  onClick={() => this.setState({ q5: 'n5' })}
                >
                  nein
                </Option>
              </OptionContainer>
            </SelfcheckSelect>
          </SelfcheckRow>
        </ContainerSelfcheck>
        <Button
          onClick={() => {
            this.setState({ active: `auswerten` })
            scrollTo('#main')
          }}
        >
          Auswerten
        </Button>
        <div className="auswertung">
          <Antwort id="a-1">
            <p>
              <SelfcheckTitle>Zugänge</SelfcheckTitle>
            </p>
            Für ein schnelles Agieren bei einem Notfall ist es erforderlich,
            dass Passwörter schnell verfügbar sind. Egal, ob Sie eine
            Fehlerbehebung selbst durchführen oder einen externen Partner
            beauftragen: das Vorhandensein der Passwörter ist ein essentieller
            Bestandteil für eine effektive Hilfestellung. Selbst wenn Sie die
            laufende IT-Betreuung durch einen externen IT-Partner erfolgt,
            sollten alle relevanten Passwörter auch im Unternehmen aufliegen.
            Fragen Sie Ihren IT-Betreuer danach, Ihnen eine Dokumentation Ihrer
            IT-Systeme auszuhändigen. Denken Sie auch daran, dass die
            Dokumentation bzw. die Passwörter an einem sicheren Ort aufbewahrt
            werden, sodass Unbefugte keinen Zugriff darauf bekommen können.
          </Antwort>
          <Antwort id="a-2">
            <p>
              <SelfcheckTitle>Sicherungen</SelfcheckTitle>
            </p>
            Es ist ganz essentiell, dass Sie die Gewissheit über die Sicherung
            Ihrer Serversysteme haben. Auch wenn ein Rückspielen von Daten im
            Ernstfall ein zeitraubendes Unterfangen ist, so haben Sie auf jeden
            Fall die Sicherheit, dass Ihre Systeme danach ohne Datenverlust
            wiederherstellbar sind. Ist bei einem Ausfall eines Servers kein
            Backup vorhanden, kann das sehr weitreichende Folgen für das
            Unternehmen haben bzw. kann eine Datenrettung aus defekten
            Festplatten sehr hohe Kosten verursachen – falls sie überhaupt
            wiederherstellbar sind. Bedenken Sie auch, dass ein einmal
            eingerichtetes Backup auch regelmäßig kontrolliert werden muss. Es
            können Umstände eintreten, wo Backupscripts nicht mehr funktionieren
            und keine automatisierten Sicherungen mehr durchgeführt werden.
            Fragen Sie Ihren IT-Betreuer nach einem Monitoring Ihrer Backups.
            Diese Tätigkeit wird meist im Rahmen eines Servicevertrages
            durchgeführt.
          </Antwort>
          <Antwort id="a-3">
            <p>
              <SelfcheckTitle>Hardware</SelfcheckTitle>
            </p>
            Vergewissern Sie sich, wie alt Ihre Serverhardware ist. Wenn Sie
            außerhalb der Herstellergarantie ist, empfehlen wir eine
            Hardware-Garantieerweiterung beim Hersteller oder bei einem anderen
            Anbieter abzuschließen. Nur dann haben Sie die Gewähr, dass
            Ersatzteile im Ernstfall schnell verfügbar sind. Sind die Geräte
            außerhalb der Herstellergarantie, kann es neben hohen Hardwarekosten
            zu mehreren Tagen Lieferzeit kommen. Wenn die Serverhardware zu alt
            ist, empfehlen wir auf neue Systeme upzugraden, da mit jedem Jahr
            die Ausfallswahrscheinlichkeit steigt – und Serverausfälle
            beeinträchtigen das Arbeiten in einem Untenehmen enorm. Ihr
            IT-Betreuer oder EXTENDIT berät Sie gerne.
          </Antwort>
          <Antwort id="a-4">
            <p>
              <SelfcheckTitle>IT Security</SelfcheckTitle>
            </p>
            Angriffe auf Server und Firewall nehmen permant zu. Die Attacken
            werden zudem immer ausgeklügelter. Nur bei regelmäßigen Updates ist
            garantiert, dass die Sicherheitslücken Ihrer IT-Systeme geschlossen
            sind. Die Hersteller bringen permanent Updates und Patches heraus,
            um die Systeme sicher zu halten.Professionelle Hacker machen sich
            etwaige Sicherheitslücken zu Nutze, um Zugriff auf Ihre Systeme zu
            bekommen. Am einfachsten schaffen sie dies bei schlecht gewarteten
            Systemen. Im schlimmsten Fall kann dann das gesamte Unternehmen lahm
            gelegt oder Identitätsdiebstähle begangen werden und horrende Kosten
            entstehen.
          </Antwort>
          <Antwort id="a-5">
            <p>
              <SelfcheckTitle>Passwortsicherheit</SelfcheckTitle>
            </p>
            Ein sicheres Passwort sollte mindestens über 12 Zeichen verfügen und
            eine Kombination aus Buchstaben, Zahlen und Sonderzeichen sein. Auf
            keinen Fall sollte es einfach zu erratenden Begriffe oder Namen
            beinhalten. Weiters sollte nicht ein Passwort für sämtliche privaten
            und beruflichen Zugänge verwendet werden. Wenn das Passwort von
            jemand gehackt wird, hat man sonst Zugriff auf sämtliche Systeme. Es
            gibt einige Tricks, wie man komplizerte und sichere Passwörter
            kreiiert – und sich diese auch merken kann. Gerne geben wir diese
            Tipps im Interesse Ihrer Unternehmenssicherheit weiter.
          </Antwort>
          <Antwort id="a-alle">
            Gratulation! Ihre IT scheint in sicheren Händen zu sein. Sie haben
            den Überblick über den Zustand Ihrer IT-Systeme und wissen im
            Notfall, welche Schritte einzuleiten sind. Bleiben Sie weiterhin so
            sorgfältig in der Wartung Ihrer Systeme, dann sollten Sie auch
            weiterhin vor ungeplanten Ausfällen verschont bleiben.
          </Antwort>
          <Hinweis>
            Wir weisen darauf hin, dass dieser IT-Self-Check keine ausführliche
            Analyse Ihrer IT-Infrastruktur ersetzt.{' '}
            <Link to={`/kontakt/`}>➔ Gerne beraten wir Sie persönlich.</Link>
          </Hinweis>
        </div>
      </Container>
    )
  }
}

export default ContentSelfcheck
